module.exports = __webpack_public_path__ + "img/user_icon.83c2d12d.svg";